import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { with_fund_request} from "../../features/userSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign,faWallet } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useT } from "../../i18n";
const Withdrawal = () => {
  const [amount, setAmount] = useState("");
  const { Info } = useSelector((state) => state.users);
   const dispatch = useDispatch();
  const { t } = useT();

  const handleSubmit = (e) => {
    e.preventDefault();
    let data = new FormData();
    data.append('phone_number',Info?.phone_number);
    data.append('amount', amount);
    data.append('remark','BANK_TRANSFER');
    data.append('request_number','');
    dispatch(with_fund_request(data));
  };



  return (
    <form className="af-screen" onSubmit={handleSubmit}>
      <div className="af-balance">
        <span className="af-balance-icon"><FontAwesomeIcon icon={faWallet} /></span>
        <div>
          <strong>₹{(Number(Info.wallet)!==0 || Info.wallet===null)?Info.wallet+'.00':Info.wallet}</strong>
          <span>{t('Total Wallet Balance')}</span>
        </div>
      </div>
      <label className="af-label" htmlFor="withdraw-amount">{t("Withdraw Fund")}</label>
      <div className="input-group">
        <i><FontAwesomeIcon icon={faIndianRupeeSign} /></i>
        <input id="withdraw-amount" placeholder={t("Enter withdraw points")} className="input_lable_deep" type="number" inputMode="numeric" value={amount} onChange={(e)=>setAmount(e.target.value)} />
      </div>
      <p className="af-hint">{t("Amount is sent to your saved bank account.")} <Link to="/add_bank_details">{t("Update bank details")}</Link></p>
      <button type="submit" className="continue-button">{t("Submit")}</button>
    </form>
  );
};

export default Withdrawal;
